hrd.PresentationManager = hrd.Class.extend({
	JSON_PROVIDER: undefined,
	init: function(options) {
		var defaults = {
			impl: 'hrd.PresentationManager',
		};
		this._super($.extend({}, defaults, options));
		this.storage = new hrd.config.PresentationStorage();
		this.defaultSettings = {
			dashboardBgColor: '#f0f2f5',
			dashletHeaderColor: '#e6e3e1',
			buttonBorder: false,
		};
		this.toolbox = new hrd.Toolbox();
		this.JSON_PROVIDER = this.toolbox.get('globals.prefs.tenant.layout.provider', hrd);
	},
	execute: function() {
		if (this.JSON_PROVIDER != undefined) {
			return dashboardInstance.invokeProvider(this.JSON_PROVIDER, 'getDashboardProperties')
				.then(pConfig => this.apply($.extend({}, this.defaultSettings, pConfig)));
		} else {
			return $.when(this.apply(this.defaultSettings));
		}
	},
	apply: function(config) {
		cssVar.set('ws-bg-color', config.dashboardBgColor);

		cssVar.set('ws-dashlet-header-bg-color', config.dashletHeaderColor);
		cssVar.set('ws-dashlet-header-button-bg-color', config.dashletHeaderColor);
		cssVar.set('ws-dashlet-default-tab-bg-color', config.dashletHeaderColor);

		var useDefaultHeaderColor = (config.dashletHeaderColor == this.defaultSettings.dashletHeaderColor);
		var buttonBorderColor = config.buttonBorder ? (useDefaultHeaderColor ? '#b6b3b1' : $.colorHelper().darken(config.dashletHeaderColor, 15)) : config.dashletHeaderColor;
		cssVar.set('ws-dashlet-header-button-border-color', buttonBorderColor);

		this.applyFont(config.fontInfo);
	},
	applyFont: function(fontInfo) {
		if (fontInfo != undefined && fontInfo.isActive) {
			// remove previous loaded fonts and add new font if needed
			var currentFamily = $('#dynamic-font-family').data('family');
			if (currentFamily != fontInfo.name) {
				$('#dynamic-font-family').detach();
			}
			if (fontInfo.ref) {
				var fontUri;
				if (currentFamily != fontInfo.name) {
					switch (fontInfo.owner) {
						case 'google':
							fontUri = `https://fonts.googleapis.com/css2?family=${fontInfo.ref}&display=swap`;
							break;
						default:
							break;
					}
					dashboardInstance.loadCSSFile(fontUri, fontInfo.name);
				}
			}
			cssVar.set('dashboard-font-family', fontInfo.family);
		}
	}
});